import Vue from 'vue'

// Framework
import AppHeader from './framework/Header'
import HeaderButton from './framework/HeaderButton'
import AppNavigation from './framework/Navigation'
import NavItem from './framework/NavItem'
import AppChat from './framework/Chat'
import ChatInterface from './framework/ChatInterface'
import ChatModal from './framework/ChatModal'

// Forms
import BSForm from './forms/BSForm'
import InputField from './forms/InputField'
import CheckboxField from './forms/CheckboxField'
import CheckboxSlider from './forms/CheckboxSlider'
import SelectField from './forms/SelectField'
import ToggleField from './forms/ToggleField'
import FileField from './forms/FileField'
import RadioSlider from './forms/RadioSlider'
import TextField from './forms/TextField'
import RichTextField from './forms/RichTextField'
import Datepicker from 'vuejs-datepicker'
import BSDate from './forms/BSDate'
import CommentField from './forms/CommentField'
import MapPolygon from './forms/MapPolygon'
import MultiImageUpload from './forms/MultiImageUpload'

// Elements
import RouteHeader from './elements/RouteHeader'
import RouteNavigation from './elements/RouteNavigation'
import Avatar from './elements/Avatar'
import BSButton from './elements/BSButton'
import BSAction from './elements/BSAction'
import BSActions from './elements/BSActions'
import BSBadge from './elements/BSBadge'
import BSCard from './elements/BSCard'
import BSTable from './elements/BSTable'
import BSTableHead from './elements/BSTableHead'
import BSButtonSort from './elements/BSButtonSort'
import BSAlert from './elements/BSAlert'
import BSModal from './elements/BSModal'
import Pagination from './elements/Pagination'
import KeywordMovement from './elements/KeywordMovement'
import Loading from './elements/Loading'
import APIQueue from './elements/APIQueue'
import ChunkProcess from './elements/ChunkProcess'
import CardLegend from './elements/CardLegend'
import MapBox from './elements/MapBox'
import Timer from './elements/Timer'

// Content
import NavSecondarySettings from './content/NavSecondarySettings'
import NavSecondaryTasks from './content/NavSecondaryTasks'
import NavSecondaryCustomer from './content/NavSecondaryCustomer'
import NavSecondaryVehicle from './content/NavSecondaryVehicle'
import NavSecondaryBookings from './content/NavSecondaryBookings'
import Discussions from './content/Discussions'
import Discussion from './content/Discussion'
import Customers from './content/Customers'
import Contacts from './content/Contacts'
import ClientGlobal from './content/ClientGlobal'
import Users from './content/Users'
import Roles from './content/Roles'
import Properties from './content/Properties'
import Notes from './content/Notes'
import Documents from './content/Documents'
import TaskList from './content/Tasks'
import TaskGroupList from './content/TaskGroups'
import Schedule from './content/Schedule'
import MyScheduleToday from './content/MyScheduleToday'
import Vehicles from './content/Vehicles'
import VehicleDash from './content/VehicleDash'
import Tracking from './content/Tracking'
import VehicleEvents from './content/VehicleEvents'
import Bookings from './content/Bookings'
import BookingCard from './content/BookingCard'
import BookingReport from './content/BookingReport'
import ListItems from './content/ListItems'
import Projects from './content/Projects'
import ProjectWorkers from './content/ProjectWorkers'
import ProjectTimers from './content/ProjectTimers'
import MyProjects from './content/MyProjects'
import MyProject from './content/MyProject'

// Modals
import BookingModal from './modals/BookingModal'

import { TuxedoInput, TuxedoRadio, TuxedoSelect, TuxedoDate, TuxedoToggle } from 'tuxedo-elements'

const components = {
  TuxedoInput,
  TuxedoRadio,
  TuxedoSelect,
  TuxedoDate,
  TuxedoToggle
}

Object.entries(components).forEach(([name, component]) => Vue.component(name, component))

Vue.component('app-header', AppHeader)
Vue.component('header-button', HeaderButton)
Vue.component('app-navigation', AppNavigation)
Vue.component('nav-item', NavItem)
Vue.component('app-chat', AppChat)
Vue.component('chat-interface', ChatInterface)
Vue.component('chat-modal', ChatModal)

Vue.component('bs-form', BSForm)
Vue.component('input-field', InputField)
Vue.component('checkbox-field', CheckboxField)
Vue.component('checkbox-slider', CheckboxSlider)
Vue.component('select-field', SelectField)
Vue.component('toggle-field', ToggleField)
Vue.component('file-field', FileField)
Vue.component('radio-slider', RadioSlider)
Vue.component('text-field', TextField)
Vue.component('rich-text-field', RichTextField)
Vue.component('datepicker', Datepicker)
Vue.component('date-field', BSDate)
Vue.component('comment-field', CommentField)
Vue.component('map-polygon', MapPolygon)
Vue.component('multi-image-upload', MultiImageUpload)

Vue.component('route-header', RouteHeader)
Vue.component('route-navigation', RouteNavigation)
Vue.component('avatar', Avatar)
Vue.component('bs-button', BSButton)
Vue.component('bs-action', BSAction)
Vue.component('bs-actions', BSActions)
Vue.component('bs-badge', BSBadge)
Vue.component('bs-card', BSCard)
Vue.component('bs-table', BSTable)
Vue.component('bs-th', BSTableHead)
Vue.component('bs-btn-sort', BSButtonSort)
Vue.component('bs-alert', BSAlert)
Vue.component('bs-modal', BSModal)
Vue.component('pagination', Pagination)
Vue.component('keyword-movement', KeywordMovement)
Vue.component('loading', Loading)
Vue.component('queue', APIQueue)
Vue.component('chunk-process', ChunkProcess)
Vue.component('card-legend', CardLegend)
Vue.component('mapbox', MapBox)
Vue.component('timer', Timer)

Vue.component('nav-secondary-settings', NavSecondarySettings)
Vue.component('nav-secondary-customer', NavSecondaryCustomer)
Vue.component('nav-secondary-tasks', NavSecondaryTasks)
Vue.component('nav-secondary-vehicle', NavSecondaryVehicle)
Vue.component('nav-secondary-bookings', NavSecondaryBookings)
Vue.component('discussions', Discussions)
Vue.component('discussion', Discussion)
Vue.component('customers', Customers)
Vue.component('contacts', Contacts)
Vue.component('client-global', ClientGlobal)
Vue.component('users', Users)
Vue.component('roles', Roles)
Vue.component('properties', Properties)
Vue.component('notes', Notes)
Vue.component('documents', Documents)
Vue.component('task-list', TaskList)
Vue.component('task-group-list', TaskGroupList)
Vue.component('schedule', Schedule)
Vue.component('my-schedule-today', MyScheduleToday)
Vue.component('vehicles', Vehicles)
Vue.component('vehicle-dash', VehicleDash)
Vue.component('tracking', Tracking)
Vue.component('vehicle-events', VehicleEvents)
Vue.component('bookings', Bookings)
Vue.component('booking-card', BookingCard)
Vue.component('booking-report', BookingReport)
Vue.component('list-items', ListItems)
Vue.component('projects', Projects)
Vue.component('project-workers', ProjectWorkers)
Vue.component('project-timers', ProjectTimers)
Vue.component('my-projects', MyProjects)
Vue.component('my-project', MyProject)

Vue.component('booking-modal', BookingModal)
